import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiService } from './api.service';

/** Shape for an individu returned by WWS search (/wws/individus/search). */
export interface WwsIndividu {
  id?: number;
  name?: string;
  /** Not always an address: some WWS tenants return the individu id here. */
  email?: string | number;
  /** E-mail address on WWS tenants where `email` holds the id. */
  mail?: string;
  mobilePhone?: string | null;
  businessPhones?: string[] | null;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class WwsService {
  private readonly api = inject(ApiService);

  /**
   * Search user position (individus) by name or query.
   * Calls GET /wws/individus/search with query params q and optional userGroupId.
   */
  searchUserPosition(params: { q?: string; userGroupId?: string }): Observable<WwsIndividu[]> {
    return this.api
      .get<WwsIndividu[]>('/wws/individus/search', {
        q: params.q ?? null,
        userGroupId: params.userGroupId ?? null,
      })
      .pipe(
        map((body) => (Array.isArray(body) ? body : [])),
        catchError(() => of([])),
      );
  }
}
